import { useGenerateAndSignProcurationStep } from './useGenerateAndSignProcurationStep'
import { GenerateAndSignProcurationStepUI } from './GenerateAndSignProcurationStepUI'

export const GenerateAndSignProcurationStep = () => {
  const props = useGenerateAndSignProcurationStep()
  return <GenerateAndSignProcurationStepUI {...props} />
}
